/* eslint-disable @typescript-eslint/consistent-type-definitions -- generated */
import {createVariableCache} from '@cosctl/environment';

// This file was automatically generated by @cosctl/environment.
// You should NOT make any changes in this file as it will be overwritten.
// Additionally, you should also exclude this file from your linter and/or formatter to prevent it from being checked or modified.

const BUILD_VARIABLES = {
  PUBLIC_APP_BRANCH: import.meta.env.PUBLIC_APP_BRANCH ?? "dev",
  PUBLIC_APP_COMMIT: import.meta.env.PUBLIC_APP_COMMIT ?? "HEAD",
  PUBLIC_APP_VERSION: import.meta.env.PUBLIC_APP_VERSION ?? "0.0.0",
  PUBLIC_RPC_BASE_URL: import.meta.env.PUBLIC_RPC_BASE_URL ?? "http://localhost:8080",
  PUBLIC_WORKOS_CLIENT_ID: import.meta.env.PUBLIC_WORKOS_CLIENT_ID ?? "",
  PUBLIC_WORKOS_REDIRECT_URI: import.meta.env.PUBLIC_WORKOS_REDIRECT_URI ?? "http://localhost:4000/",
}

createVariableCache(BUILD_VARIABLES);
  
declare module '@cosctl/environment' {
  interface Register {
    variables: typeof BUILD_VARIABLES;
  }
}

declare global {
  /**
   * Type augmentation for import.meta.env
   * Provides TypeScript autocompletion for environment variables
   */
  interface ImportMeta {
    readonly env: ImportMetaEnv;
  }

  interface ImportMetaEnv {

    /** Git branch the application was built from @default "dev" */
    readonly PUBLIC_APP_BRANCH: string;

    /** Git commit the application was built from @default "HEAD" */
    readonly PUBLIC_APP_COMMIT: string;

    /** Application version number @default "0.0.0" */
    readonly PUBLIC_APP_VERSION: string;

    /** RPC base URL @default "http://localhost:8080" */
    readonly PUBLIC_RPC_BASE_URL: string;

    /** WorkOS client ID @default "" */
    readonly PUBLIC_WORKOS_CLIENT_ID: string;

    /** WorkOS redirect URI @default "http://localhost:4000/" */
    readonly PUBLIC_WORKOS_REDIRECT_URI: string;

  }

  // eslint-disable-next-line no-var
  var __ENV__: Record<string, string>;
}

export {
  BUILD_VARIABLES
};
/* eslint-enable @typescript-eslint/consistent-type-definitions -- generated */
